import { DownloadSimple, GoogleDriveLogo, EnvelopeSimple } from "@phosphor-icons/react";

function ChoiceBtn({ Icon, label, desc, onClick, disabled = false, testid }) {
  return (
    <button
      className={`text-left border p-4 flex items-start gap-3 transition-colors ${disabled ? "border-zinc-300 bg-zinc-100 opacity-60 cursor-not-allowed" : "border-black hover:bg-zinc-900 hover:text-white"}`}
      onClick={onClick}
      disabled={disabled}
      data-testid={testid}
    >
      <Icon size={28} weight="bold" className="mt-0.5 flex-shrink-0" />
      <div>
        <div className="font-bold">{label}</div>
        <div className="text-xs opacity-80 mt-0.5">{desc}</div>
      </div>
    </button>
  );
}

export default function BackupChoiceModal({ config, onRun, onClose }) {
  return (
    <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center p-4" onClick={onClose}>
      <div
        className="bg-white border border-black w-full max-w-lg"
        onClick={(e) => e.stopPropagation()}
        data-testid="backup-choice-modal"
      >
        <div className="border-b border-black px-6 py-4">
          <div className="font-head font-bold text-lg">Escolha o destino do backup</div>
          <div className="text-xs text-zinc-500 mt-1">O sistema vai gerar um dump completo do banco (~alguns MB).</div>
        </div>
        <div className="p-6 grid grid-cols-1 gap-3">
          <ChoiceBtn
            Icon={DownloadSimple}
            label="Baixar no computador"
            desc="Gera o arquivo e faz download direto pro navegador."
            onClick={() => onRun("download")}
            testid="choice-download"
          />
          <ChoiceBtn
            Icon={GoogleDriveLogo}
            label="Enviar ao Google Drive"
            desc={config?.drive_configured ? `Pasta configurada · ${config?.drive_service_account_email || ""}` : "⚠ Drive ainda não configurado nas Configurações."}
            onClick={() => onRun("drive")}
            disabled={!config?.drive_configured}
            testid="choice-drive"
          />
          <ChoiceBtn
            Icon={EnvelopeSimple}
            label="Enviar por e-mail"
            desc={config?.email_recipients?.length ? `Envia para: ${config.email_recipients.join(", ")}` : "⚠ Nenhum e-mail configurado."}
            onClick={() => onRun("email")}
            disabled={!config?.email_recipients?.length}
            testid="choice-email"
          />
        </div>
        <div className="border-t border-black px-6 py-3 flex justify-end">
          <button className="btn btn-ghost" onClick={onClose}>Cancelar</button>
        </div>
      </div>
    </div>
  );
}
